import { css } from "styled-components";

export const desktopMedia = (...args: Parameters<typeof css>) => css`
    @media (min-width: 1920px) {
        ${css(...args)}
    }
`;
